import { ThemeDefinition } from 'vuetify';

// Vård och omsorg
export const healthAndSocialCare: ThemeDefinition = {
  dark: false,
  colors: {
    'subject-original': '#946782',
    'on-subject-original': '#FFFFFF',
    subject: '#895875',
    'on-subject': '#FFFFFF',
    primary: '#814669',
    'on-primary': '#FFFFFF',
    'primary-container': '#E4CDDB',
    'on-primary-container': '#281520',
    secondary: '#62515B',
    'on-secondary': '#FFFFFF',
    'secondary-container': '#DDD5DA',
    'on-secondary-container': '#221C1F',
    surface: '#FBF9FA',
    'on-surface': '#201D1F',
    'on-surface-medium': '#50494D',
    'on-surface-low': '#9E949A',
    outline: '#867981',
    'outline-variant': '#CFC9CD',
    'inverse-surface': '#3B2B35',
    'inverse-on-surface': '#F6EEF3',
    'inverse-primary': '#D5C3CE',
    'surface-dim': '#DECED8',
    'surface-bright': '#FDFCFD',
    'surface-container-lowest': '#FFFFFF',
    'surface-container-low': '#F7F3F5',
    'surface-container': '#F3EDF0',
    'surface-container-high': '#EBE0E7',
    'surface-container-highest': '#E7DAE2',
  },
};

export const healthAndSocialCareDark: ThemeDefinition = {
  dark: true,
  colors: {
    'subject-original': '#946782',
    'on-subject-original': '#FBF9FA',
    subject: '#C6AEBD',
    'on-subject': '#241920',
    primary: '#E1C7D6',
    'on-primary': '#281520',
    'primary-container': '#633651',
    'on-primary-container': '#F6EEF3',
    secondary: '#D6CDD2',
    'on-secondary': '#221C1F',
    'secondary-container': '#54454E',
    'on-secondary-container': '#F4F1F3',
    surface: '#181015',
    'on-surface': '#F3F2F2',
    'on-surface-medium': '#CFC9CD',
    'on-surface-low': '#867981',
    outline: '#867981',
    'outline-variant': '#6B6167',
    'inverse-surface': '#E9E2E6',
    'inverse-on-surface': '#231A20',
    'inverse-primary': '#3C2A35',
    'surface-dim': '#150E13',
    'surface-bright': '#462F3D',
    'surface-container-lowest': '#120C10',
    'surface-container-low': '#1F141B',
    'surface-container': '#281B22',
    'surface-container-high': '#34232D',
    'surface-container-highest': '#432D3A',
  },
};
